import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function allPlanReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_ALL_PLANS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_ALL_PLANS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.GET_ALL_PLANS_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
